import { isDevEnvironment, isStagingEnvironment, isProductionEnvironment } from 'services/shared/Environment'

function getBaseUrl() {
  if (typeof window === "undefined") return null;
  if (isDevEnvironment()) {
    if (window.location.port === "3000") {
      return `http://localhost:3001`;
    } else {
      return `http://localhost:3000`;
    }
  }

  if (isStagingEnvironment()) {
    if (window.location.hostname.includes("jgnt.co")) {
      return `https://staging.read.jgnt.co`;
    } else {
      return `https://staging.read.thejuggernaut.com`;
    }
  }

  if (isProductionEnvironment()) {
    if (window.location.hostname.includes("jgnt.co")) {
      return `https://read.jgnt.co`;
    } else {
      return `https://read.thejuggernaut.com`;
    }
  }
}

export function getCsrfTokenEndpoint() {
  if (!getBaseUrl()) return "";
  return `${getBaseUrl()}/api/testing/csrf`;
}

export function getLoginEndpoint() {
  if(!getBaseUrl()) return ""
  return `${getBaseUrl()}/api/auth/login`
}

export function getLogoutEndpoint() {
  if(!getBaseUrl()) return ""
  return `${getBaseUrl()}/api/auth/logout`
}